import * as React from 'react';
import PreOrderRequestNewPage from './PreOrderRequestNewPage';
var AdminPreOrderRequestNewPage = function () {
    return React.createElement(PreOrderRequestNewPage, null);
};
export default AdminPreOrderRequestNewPage;
